<script setup lang="ts">
import { defineProps } from "vue";

interface Props {
  modelValue?: string | null;
  placeholder?: string;
  type?: "text" | "email" | "password";
  disabled?: boolean;
  size?: "medium" | "big" | "plus" | "small";
  fullWidth?: boolean;
  high?: boolean;
  theme?:
    | "transparent"
    | "green-bold"
    | "active-bold"
    | "dark-wireframe"
    | "clear-wireframe"
    | "dark-bold"
    | "clear-bold"
    | "iron-bold"
    | "gray-bold";
  shape?: "round" | "square";
}

const props = withDefaults(defineProps<Props>(), {
  type: "text",
  disabled: false,
  size: "medium",
  shape: "round",
  fullWidth: false,
  high: false,
  theme: "transparent",
});
</script>

<template>
  <input
    :value="modelValue"
    @input="$emit('update:modelValue', ($event.target! as HTMLInputElement).value)"
    :type="type"
    :class="[
      'pill',
      {
        [`pill--${size}`]: size,
        'pill--high': high,
        [`pill--${theme}`]: theme,
        [`pill--${shape}`]: shape,
        'pill--full-width': fullWidth,
      },
    ]"
    :disabled="disabled"
    :placeholder="props.placeholder"
  />
</template>

<style scoped lang="scss"></style>
